import { render, staticRenderFns } from "./CDR.vue?vue&type=template&id=36aed776&"
import script from "./CDR.vue?vue&type=script&lang=js&"
export * from "./CDR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports